import type { TFunction } from 'i18next';

/** Error thrown by apiFetch when the API returns a machine code. */
export class ApiError extends Error {
  code?: string;
  status?: number;
  payload?: unknown;

  constructor(message: string, opts?: { code?: string; status?: number; payload?: unknown }) {
    super(message);
    this.name = 'ApiError';
    this.code = opts?.code;
    this.status = opts?.status;
    this.payload = opts?.payload;
  }
}

/**
 * Prefer mapping by API `code`. Falls back to known FR message hashes, then raw message.
 */
export function translateApiError(
  err: unknown,
  t: TFunction<'errors'>,
  fallbackKey = 'generic',
): string {
  if (err instanceof ApiError && err.code) {
    const keyed = t(`codes.${err.code}`, { defaultValue: '' });
    if (keyed) return keyed;
  }
  const msg = err instanceof Error ? err.message : typeof err === 'string' ? err : '';
  if (msg) {
    const byMsg = t(`messages.${msg}`, { defaultValue: '' });
    if (byMsg) return byMsg;
  }
  if (msg) return msg;
  return t(fallbackKey);
}

export function errorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}
